import { render } from "./KochTrainer.vue?vue&type=template&id=fbce65dc"
import script from "./KochTrainer.vue?vue&type=script&lang=js"
export * from "./KochTrainer.vue?vue&type=script&lang=js"

import "./KochTrainer.vue?vue&type=style&index=0&id=fbce65dc&lang=css"
script.render = render

export default script